import { ProjectCMSWidget } from './project-widget'

export interface Project {
  id?: string
  name: string
  templateId?: string

  active: boolean

  configuration: ProjectConfiguration
  cms: ProjectCMS
  multilingual: ProjectMultilingual[]
}

export interface ProjectConfiguration {
  generalConfig: ProjectGeneralConfig
  customizationGlobalConfig?: ProjectCustomizationGlobalConfig
  customizationActiveMenuConfig?: ProjectMenuCustomization
  customizationInactiveMenuConfig?: ProjectMenuCustomization
  pageConfig?: ProjectCMSPageConfig[]
}

export interface ProjectGeneralConfig {
  defaultLanguage: string
  supportedLanguages: string[]
  menuOrientation: string
  menuType: MenuType
  showMenuBackground: boolean
  menuBackgroundColor?: string
}

export interface ProjectCustomizationGlobalConfig {
  menuMargin: number
  menuPosition: MenuPosition
  menuSize: MenuSize
  menuContainerSize?: number | null
  imagePosition: ImagePositionAndSize
  textPosition: TextPositionAndSize
}

export interface ProjectMenuCustomization {
  cornerRadius: number
  opacity: number
  text?: ProjectMenuCustomizationText
  shadow?: ProjectMenuCustomizationShadow
  underline?: ProjectMenuCustomizationUnderline
}

export interface ProjectMenuCustomizationText {
  fontSize: number
  fontWeight?: string
  fontStyle?: string
  textDecoration?: string
  color?: string
  textAlign?: string
}

export interface ProjectMenuCustomizationShadow {
  shadowEnabled: boolean
  shadowBlur: number
  shadowOffsetX: number
  shadowOffsetY: number
  shadowColor?: string
  shadowOpacity: number
}

export interface ProjectMenuCustomizationUnderline {
  underlineMenu: boolean
  underlineColor: string
  underlineThickness: number
  underlineWidth?: number
}

export interface ProjectCMSPageConfig {
  type: ProjectCMSRouterPageType
  pageId: string
}

export interface ProjectCMS {
  startPageId: string
  pages: ProjectCMSPage[]
}

export interface ProjectCMSPage {
  id: string
  htmlContent: string
  menus: ProjectCMSMenu[]
  widgets: ProjectCMSWidget[]
}

export interface ProjectCMSMenu {
  id?: string

  position: number

  labelTranslationId: string
  mediaTranslationId: string

  label?: string
  mediaSrc?: string

  actionType: ProjectCMSButtonActionType
  actionAppId?: string
  actionNavigationPageId?: string
  actionNavigationUrl?: string
  actionTvChannelId?: string
  actionLanguageCode?: string
  actionSpecificSubType?: SpecificActionSubType
  actionHdmiPort?: number

  pmsStatus?: PmsStatus
  default?: boolean
  predefinedImage?: MenuPredefinedImage
}

export interface ProjectMultilingual {
  translationId?: string
  translations?: Record<string, string>
}

export interface MenuPosition {
  x: number
  y: number
}

export interface MenuSize {
  width: number
  height: number
}

export interface ImagePositionAndSize {
  x: number
  y: number
  width: number
  height: number
}

export interface TextPositionAndSize {
  x: number
  y: number
  width: number
}

export enum MenuPredefinedImage {
  GOOGLE_CAST_BLUE = 'GOOGLE_CAST_BLUE',
  GOOGLE_CAST_BLACK = 'GOOGLE_CAST_BLACK',
  GOOGLE_CAST_WHITE = 'GOOGLE_CAST_WHITE',
}

export enum ProjectCMSButtonActionType {
  START_TV = 'START_TV',
  OPEN_APP = 'OPEN_APP',
  OPEN_APPS = 'OPEN_APPS',
  PAGE_NAVIGATION = 'PAGE_NAVIGATION',
  OPEN_CAST = 'OPEN_CAST',
  OPEN_GOOGLE_CAST = 'OPEN_GOOGLE_CAST',
  OPEN_HDMI = 'OPEN_HDMI',
  OPEN_URL = 'OPEN_URL',
  OPEN_TV_GUIDE = 'OPEN_TV_GUIDE',
  OPEN_IPG = 'OPEN_IPG',
  OPEN_VOD = 'OPEN_VOD',
  CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
  OPEN_WAKE_UP_ALARM = 'OPEN_WAKE_UP_ALARM',
  SET_LANGUAGE = 'SET_LANGUAGE',
  SPECIFIC_ACTION = 'SPECIFIC_ACTION',
}

export enum SpecificActionSubType {
  DELETE_MESSAGE = 'DELETE_MESSAGE',
  BILL_NEXT_PAGE = 'BILL_NEXT_PAGE',
  BILL_PREVIOUS_PAGE = 'BILL_PREVIOUS_PAGE',
  BILL_EXPRESS_CHECKOUT = 'BILL_EXPRESS_CHECKOUT',
  ALARM_CREATE = 'ALARM_CREATE',
  ALARM_STOP = 'ALARM_STOP',
  ALARM_SNOOZE = 'ALARM_SNOOZE',
}

export enum MenuType {
  TEXT_AND_IMAGE = 'TEXT_AND_IMAGE',
  TEXT_ONLY = 'TEXT_ONLY',
  IMAGE_ONLY = 'IMAGE_ONLY',
}

export enum PmsStatus {
  CHKI_AND_CHKO = 'CHKI_AND_CHKO',
  CHKI = 'CHKI',
  CHKO = 'CHKO',
}

export enum ProjectCMSRouterPageType {
  APP_GRID = 'APP_GRID',
  CAST = 'CAST',
  CAST_DONGLE = 'CAST_DONGLE',
  CHANNEL = 'CHANNEL',
  CHANNEL_GRID = 'CHANNEL_GRID',
  CHANNEL_IPG = 'CHANNEL_IPG',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  LANGUAGE_SELECTOR = 'LANGUAGE_SELECTOR',
  WAKE_UP_ALARM = 'WAKE_UP_ALARM',
  WAKE_UP_ALARM_RINGING = 'WAKE_UP_ALARM_RINGING',
  CREATE_WAKE_UP_ALARM = 'CREATE_WAKE_UP_ALARM',
}
